import React from "react";
import ReactDOM from "react-dom";
import { getOwnerFromStorefront, hostnameToStorefront } from "@glamcorner/core-cf-lib/lib/client";
import { AccountsEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { isTouchDevice } from "../common/util";
import "../utils/setWebpackPublicPath";
import { ResponsiveNav } from "./ResponsiveNav";
import { ResponsiveWindow } from "./ResponsiveWindow";

(function () {
  /* ---------------------------------------------
     Scripts initialization
     --------------------------------------------- */
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof window.jQuery === "function") init_shortcodes(window.jQuery);
  });

  // Detect touch devices
  if (!isTouchDevice()) {
    document.documentElement.className += " no-touch";
  }

  /* ---------------------------------------------
     Shortcodes
     --------------------------------------------- */
  // Tabs minimal
  // TODO: Might be able to delete this because can't find usage, also uses slideDown which is jquery specific
  function init_shortcodes($) {
    // Accordion
    var allPanels = $(".accordion > dd").hide();
    allPanels.first().slideDown("easeOutExpo");
    $(".accordion > dt > a").first().addClass("active");

    $(".accordion > dt > a").click(function () {
      var current = $(this).parent().next("dd");
      $(".accordion > dt > a").removeClass("active");
      $(this).addClass("active");
      allPanels.not(current).slideUp("easeInExpo");
      $(this).parent().next().slideDown("easeOutExpo");

      return false;
    });

    // Toggle
    $(".toggle > dd:not('.initialview')").hide();

    $(".toggle > dt > a").click(function () {
      if ($(this).hasClass("active")) {
        $(this).parent().next().slideUp("easeOutExpo");
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
        $(this).parent().next().slideDown("easeOutExpo");
      }

      return false;
    });
  }
})();

(function () {
  // This is only used for GC button i think
  document.querySelector("body").classList.add("havent-seen-touch-event");
  window.addEventListener(
    "touchstart",
    function setHasTouch() {
      document.querySelector("body").classList.remove("havent-seen-touch-event");
      document.querySelector("body").classList.add("seen-touch-event");

      window.removeEventListener("touchstart", setHasTouch);
    },
    false
  );

  window.GC = window["GC"] || {};
  // TODO: Delete this whole thing after migration to use webflow nav
  if (typeof window.jQuery === "function") {
    window.GC.responsiveWindow = new ResponsiveWindow(new ResponsiveNav());
  }

  const storefront = hostnameToStorefront();
  const owner = getOwnerFromStorefront(storefront);
  const onePageCheckout = window.location.pathname === "/cart/checkout";
  const homePage = window.location.pathname === "" || window.location.pathname === "/";

  if (!onePageCheckout) {
    const onDemandNavCartEl = document.querySelector(".js-ondemand-cart-root");
    if (onDemandNavCartEl) {
      import("./cartMenu").then((importedModule) => {
        importedModule.initCartMenu(onDemandNavCartEl);
      });
    }

    GlamCornerCore.bus.on(AccountsEvents.CustomerLogin, {}, (data) => {
      const accountNavIconRootElement = document.querySelector(".js-account-nav-icon-root");
      if (accountNavIconRootElement) {
        import("./accountMenu").then((importedModule) => {
          importedModule.initAccountMenu(accountNavIconRootElement, GlamCornerCore.bus);
        });
      }

      if (data.subscriptionType && data.subscriptionType !== "none") {
        const subscriptionNavBoxEl = document.querySelector(".js-subscription-box-root");
        if (subscriptionNavBoxEl) {
          subscriptionNavBoxEl.style.display = "block";
          import("./subscriptionBoxMenu").then((importedModule) => {
            importedModule.initSubscriptionBoxMenu(subscriptionNavBoxEl);
          });
        }
        const mobileApplicationPromptRoot = document.querySelector(".js-mobile-application-prompt-root");
        if (mobileApplicationPromptRoot) {
          mobileApplicationPromptRoot.style.display = "block";
          import("./MobileApplicationPromptGeneral/MobileApplicationPromptGeneral").then((importedModule) => {
            importedModule.initMobileApplicationPrompt(mobileApplicationPromptRoot);
          });
        }
      }
    });
  }

  if (homePage) {
    const storefrontModalElement = document.querySelector(".js-storefront-modal-root");
    if (storefrontModalElement) {
      if (
        owner === "davidjones" &&
        (window.document.referrer.includes("davidjones.com") ||
          window.location.hostname.includes("local") ||
          window.location.hostname.includes("staging"))
      ) {
        import("./components/DavidJonesStorefrontModal/DavidJonesStorefrontModal").then((importedModule) => {
          const DavidJonesStorefrontModal = importedModule.DavidJonesStorefrontModal;
          ReactDOM.render(<DavidJonesStorefrontModal />, storefrontModalElement);
        });
      }
    }
  }

  const clickables = Array.from(document.querySelectorAll("[data-clickable]"));
  clickables.forEach((clickable) => {
    clickable.addEventListener("click", (event) => {
      console.log(event.target);
      if (event.target.tagName !== "A") {
        const delegateElementSelector = clickable.attributes["data-clickable"].value;
        const link = clickable.querySelector(delegateElementSelector);
        window.location = link.href;
        return false;
      }
    });
  });

  (function () {
    let searchIsVisible = false;
    const mainNavSelector = "main-nav";
    const searchNavItemSelector = "nav-search";
    const searchFieldSelector = "js-nav-search__field";
    const mainNavExpandedClass = "-search-expanded";
    const searchExpandedClass = "nav-search__field--expanded";

    // Only run when we have magento nav
    if (document.querySelector(`.${searchNavItemSelector}`)) {
      const setSearchIsVisible = (show) => {
        const mainNav = document.querySelector(`.${mainNavSelector}`);
        const searchField = document.querySelector(`.${searchFieldSelector}`);

        [
          [mainNav, mainNavExpandedClass],
          [searchField, searchExpandedClass],
        ].forEach(([element, expandedClass]) => {
          if (show) {
            element.classList.add(expandedClass);
          } else {
            element.classList.remove(expandedClass);
          }
        });
        searchIsVisible = show;
      };

      const mobileAndDesktopSearchNavs = document.querySelectorAll(`.${searchNavItemSelector}`);
      mobileAndDesktopSearchNavs.forEach((nav) => {
        nav.addEventListener("click", () => setSearchIsVisible(true));
      });

      document.addEventListener("click", ({ target }) => {
        if (target && target.classList) {
          const targetPartOfSearchBar =
            target.classList.contains(searchFieldSelector) || target.classList.contains(searchNavItemSelector);
          if (searchIsVisible && !targetPartOfSearchBar) {
            setSearchIsVisible(false);
          }
        }
      });

      document.addEventListener("keyup", ({ keyCode }) => {
        const escapeKeyCode = 27;
        if (keyCode === escapeKeyCode) {
          setSearchIsVisible(false);
        }
      });
    }
  })();
})();
